import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es7.array.includes.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import '@web/shared-digital-library/icons/svg-originals/infobulle.svg';
import '@web/shared-digital-library/icons/svg-originals/geoloc.svg';
import { mapGetters, mapActions } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import Banner from '~/components/specific/MainHeader/Banner.vue';
import BannerMobile from '~/components/specific/MainHeader/BannerMobile.vue';
import LayerFullscreenHeader from '~/components/specific/MainHeader/LayerFullscreenHeader.vue';
import LayerMobile from '~/components/specific/MainHeader/LayerMobile.vue';
import NavigationBar from '~/components/specific/MainHeader/NavigationBar.vue';
import { FAQ } from '~/const/faq';
import USE_MERCURE from '~/const/mercure';
import focusElement from '~/helpers/a11y-helpers';
import marketClosed from '~/helpers/marketClosed';
var LayerDesktop = () => import('~/components/specific/MainHeader/LayerDesktop.vue');
export default {
  name: 'MainHeader',
  components: {
    Banner,
    BannerMobile,
    NavigationBar,
    LayerFullscreenHeader,
    LayerMobile,
    LayerDesktop
  },
  props: {
    hashFirstCat: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isMenuOpened: '',
      selectedItem: null,
      scrollPosition: 0,
      displayNavBar: true,
      enableNavTransition: false,
      lastActiveElement: null,
      stickyFilters: null,
      routesOnNavModifications: ['market-language-c-alias', 'market-language-p-alias'],
      allRoutesForScrambleLinksExept: ['market-language']
    };
  },
  head() {
    return {
      bodyAttrs: {
        class: this.bodyClasses
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    homeUrl: 'i18n/homeUrl',
    user: 'user/me',
    navigation: 'navigationBar/navigation',
    navigationServices: 'navigationBar/navigationServices'
  })), {}, {
    isCurrentRouteNeedsScrambleLinksForHeader() {
      return !this.allRoutesForScrambleLinksExept.includes(this.$route.name);
    },
    isCurrentRouteNeedsSEOOptimisation() {
      return this.routesOnNavModifications.includes(this.$route.name);
    },
    hashFromBreadcrumb() {
      return this.getHash();
    },
    navigationFiltered() {
      var _this$navigation;
      var cloneNav;
      var isConfigReadyForNewMenu = !!(this.isCurrentRouteNeedsSEOOptimisation && this.hashFromBreadcrumb);
      if (isConfigReadyForNewMenu) {
        cloneNav = cloneDeep(this.navigation);
      }
      var isFlatable = menuItem => menuItem.flatable;
      var menuProductsIndex = (_this$navigation = this.navigation) === null || _this$navigation === void 0 ? void 0 : _this$navigation.findIndex(isFlatable);
      return isConfigReadyForNewMenu ? this.setNewMenu({
        menu: cloneNav,
        menuProductsIndex,
        hash: this.hashFromBreadcrumb
      }) : this.navigation;
    },
    bodyClasses() {
      return this.isMenuOpened ? 'no-scroll w-100' : '';
    },
    accountUrl() {
      if (this.user && USE_MERCURE(this.locale.iso)) {
        return "".concat(this.homeUrl, "/user");
      }
      if (USE_MERCURE(this.locale.iso)) {
        return "".concat(this.homeUrl, "/login");
      }
      return "".concat(this.homeUrl, "/account/dashboard");
    },
    faqUrl() {
      return FAQ.find(e => e.language === this.locale.iso).url;
    },
    urls() {
      return {
        cartUrl: this.buildCartUrl(this.locale),
        homeUrl: this.homeUrl,
        storeLocUrl: "".concat(this.homeUrl, "/store-locator"),
        helpUrl: this.faqUrl,
        accountUrl: this.accountUrl
      };
    },
    isMarketOpen() {
      if (!this.locale) return true;
      var {
        market
      } = this.locale;
      return !marketClosed({
        market
      });
    }
  }),
  mounted() {
    var _this = this;
    return _asyncToGenerator(function* () {
      var draftId = _this.$cookies.get('NAVIGATION_PREVIEW');
      if (draftId) {
        if (_this.$cookies.get('debugmdm')) _this.$logger.debug('Previewing draft', draftId);
        try {
          yield _this.navigationBarContent({
            draftId
          });
        } catch (e) {
          _this.$logger.error(e);
        }
      }
      document.addEventListener('click', _this.onClickOutside);
      window.addEventListener('scroll', _this.handleScroll, {
        passive: true
      });
      _this.scrollPosition = window.pageYOffset;
      _this.displayNavBar = !_this.isMobile();
      _this.$nextTick(() => {
        _this.enableNavTransition = true;
      });
    })();
  },
  destroyed() {
    document.removeEventListener('click', this.onClickOutside);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    navigationBarContent: 'navigationBar/navigationBarContent'
  })), {}, {
    getHash() {
      var _this$$store, _this$$store2;
      var indexInBreadcrumbToGetHashCategory = 1;
      var breadcrumbFromProductPage = (_this$$store = this.$store) === null || _this$$store === void 0 ? void 0 : _this$$store.getters['product/breadcrumb'];
      var breadcrumbFromCategoryPage = (_this$$store2 = this.$store) === null || _this$$store2 === void 0 ? void 0 : _this$$store2.getters['category/breadcrumb'];
      if (breadcrumbFromProductPage) {
        var _breadcrumbFromProduc;
        return (_breadcrumbFromProduc = breadcrumbFromProductPage[indexInBreadcrumbToGetHashCategory]) === null || _breadcrumbFromProduc === void 0 ? void 0 : _breadcrumbFromProduc.hash;
      }
      if (breadcrumbFromCategoryPage) {
        var _breadcrumbFromCatego;
        return (_breadcrumbFromCatego = breadcrumbFromCategoryPage[indexInBreadcrumbToGetHashCategory]) === null || _breadcrumbFromCatego === void 0 ? void 0 : _breadcrumbFromCatego.hash;
      }
      return null;
    },
    setNewMenu(_ref) {
      var _newMenu$menuProducts;
      var {
        menu = null,
        menuProductsIndex,
        hash
      } = _ref;
      var newMenu = menu;
      var categoryIndexToNoScramble = newMenu === null || newMenu === void 0 ? void 0 : (_newMenu$menuProducts = newMenu[menuProductsIndex]) === null || _newMenu$menuProducts === void 0 ? void 0 : _newMenu$menuProducts.items.findIndex(menu => JSON.stringify(menu).includes(hash));
      if (categoryIndexToNoScramble !== -1) {
        var _newMenu$menuProducts2;
        this.addScrumbleLinks({
          arrayItems: newMenu === null || newMenu === void 0 ? void 0 : (_newMenu$menuProducts2 = newMenu[menuProductsIndex]) === null || _newMenu$menuProducts2 === void 0 ? void 0 : _newMenu$menuProducts2.items,
          indexArrayItemNoScramble: categoryIndexToNoScramble
        });
      }
      return newMenu;
    },
    addScrumbleLinks(_ref2) {
      var {
        arrayItems = [],
        indexArrayItemNoScramble = null
      } = _ref2;
      arrayItems.forEach(menuEle => {
        var menuEleCopy = menuEle;
        menuEleCopy.isScrambleLink = true;
      });
      if (indexArrayItemNoScramble || indexArrayItemNoScramble === 0) {
        var menuProductToOptimise = arrayItems === null || arrayItems === void 0 ? void 0 : arrayItems[indexArrayItemNoScramble];
        if (menuProductToOptimise) menuProductToOptimise.isScrambleLink = false;
      }
    },
    openMenu(items) {
      this.selectedItem = items;
      if (items === 'mobile') {
        this.isMenuOpened = 'mobile';
      } else {
        this.isMenuOpened = items && this.isMenuOpened !== items.label ? items.label : '';
        this.lastActiveElement = document.activeElement;
        this.$nextTick(() => focusElement(this.$refs.layerFullscreen.$refs.close.$el));
      }
    },
    closeMenu() {
      this.isMenuOpened = '';
      this.selectedItem = null;
      this.$refs.layerMobile.close();
    },
    handleScroll() {
      if (this.isMobile()) {
        this.displayNavBar = false;
        return;
      }
      var scroll = window.pageYOffset;
      this.displayNavBar = this.scrollPosition > scroll || scroll <= 1;
      this.scrollPosition = scroll;
    },
    onClickOutside(event) {
      var {
        navigationBar,
        layerFullscreen,
        bannerMobile,
        layerMobile
      } = this.$refs;
      if (!navigationBar || navigationBar.$el.contains(event.target) || !layerFullscreen || layerFullscreen.$el.contains(event.target) || !bannerMobile || bannerMobile.$el.contains(event.target) || !layerMobile || layerMobile.$el.contains(event.target)) return;
      this.closeMenu();
    }
  })
};